var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnonymousAr18X18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a0a09f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "anonymous-AR-18x18Asset 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.3,10.62A2.26,2.26,0,0,1,8.93,8L9.5,7.8a1.45,1.45,0,0,0,1.05-1.38A1.4,1.4,0,0,0,9,4.94,1.66,1.66,0,0,0,7.38,6.63H5.59A3.33,3.33,0,0,1,9.07,3.12a3.13,3.13,0,0,1,3.34,3.23A3.21,3.21,0,0,1,10.12,9.5C9.47,9.72,9,9.9,9,10.62v.44H7.32Zm-.43,3a1.28,1.28,0,0,1,2.55,0,1.28,1.28,0,0,1-2.55,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM9,17a8,8,0,1,1,8-8A8,8,0,0,1,9,17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymousAr18X18);
export default __webpack_public_path__ + "static/media/anonymous-AR-18x18.2325a77fccae25dcf95193da7d905372.svg";
export { ForwardRef as ReactComponent };